export default "__VITE_ASSET__BeZiwE3w__"